import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import * as memberAction from "../../../../redux/actions/member.action";
import List from "../../../list/list";
import { formatDate } from "../../../../helpers/date";
import RetireePortalToggle from "../../../RetireePortalToggle/RetireePortalToggle";

const memberFields = [
  //list will sort by the first element by default
  "name",
  "type",
  "short_name",
  "dor_code",
  "zip_code",
  "phone",
  "location_has_retiree_portal",
  "publishedAt",
];

const MemberList = () => {
  const dispatch = useDispatch();
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { members, meta, listLoading } = useSelector((state) => ({
    members: state.member.memberList,
    meta: state.member.memberMetadata,
    listLoading: state.member.listLoading,
  }));

  useEffect(() => {
    memberAction.fetchAll(dispatch);
  }, [dispatch]);

  const handleToggleRetireePortal = async (memberId, currentStatus) => {
    // Clear any previous messages
    setAlertMessage("");
    setErrorMessage("");
    setShowAlert(false);

    try {
      // Find the member data to send complete information
      const memberToUpdate = members?.data?.find(member => member.id === memberId);
      if (!memberToUpdate) {
        throw new Error('Member not found');
      }

      const formData = new FormData();
      const { attributes } = memberToUpdate;
      const newStatus = !attributes.location_has_retiree_portal;
      const formBody = { ...attributes, location_has_retiree_portal: newStatus };

      formData.append("location", JSON.stringify(formBody));
      await memberAction.update(dispatch, memberId, formData);

      // Show success message
      const action = newStatus ? "enabled" : "disabled";
      setAlertMessage(`Medicare portal ${action} successfully for ${attributes.name}`);
      setShowAlert(true);

      // Refresh the list to show updated data
      memberAction.fetchAll(dispatch);

      // Hide alert after 3 seconds
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    } catch (error) {
      console.error('Error toggling retiree portal:', error);
      setErrorMessage('Failed to update retiree portal status. Please try again.');
    }
  };

  return (
    <List
      showAlert={showAlert}
      setShowAlert={setShowAlert}
      successAlertMessage={alertMessage}
      customListError={errorMessage}
      redirect="/members/form"
      tooltipTextDelete="Delete Member"
      title="Members"
      columnNames={["NAME", "TYPE", "SHORT NAME", "DOR CODE", "ZIP CODE", "PHONE", "LOCATION HAS RETIREE PORTAL", "DATE"]}
      entities={members?.data?.map(
        ({
          id,
          attributes: {
            name,
            type,
            short_name,
            dor_code,
            zip_code,
            phone,
            location_has_retiree_portal,
            publishedAt,
          },
        }) => ({
          id,
          columns: [
            { primary: name },
            { primary: type },
            { primary: short_name },
            { primary: dor_code },
            { primary: zip_code },
            { primary: phone },
            { 
              primary: (
                <RetireePortalToggle
                  id={id}
                  showInRetireePortals={location_has_retiree_portal}
                  onClick={(memberId) => handleToggleRetireePortal(memberId, location_has_retiree_portal)}
                />
              )
            },
            { primary: formatDate(publishedAt) },
          ],
          name,
        })
      )}
      showFilterTab={false}
      fieldsToSort={memberFields}
      fetchAction={(params) => memberAction.fetchAll(dispatch, params)}
      metadata={meta}
      deleteAction={(id, params) => memberAction.remove(dispatch, id, params)}
      isOverview={false}
      loading={listLoading}
      tab="general"
    />
  );
};

export default MemberList;
